export default {
    // 死亡保険控除額計算
    deathKouzyo(price03, memberCount) {
        const basePrice = memberCount.total * 500;
        let rtnPrice = 0;
        if (price03 > basePrice) {
            rtnPrice = basePrice;
        } else {
            rtnPrice = price03;
        }
        return rtnPrice;
    },

    // ターゲットの人数計算
    targetMemberCount(family) {
        let count = 0;
        let childCount = 0;
        let parentCount = 0;
        let brotherCount = 0;

        // 配偶者
        family.spouse.forEach((row, i) => {
            if (i === 0 && !row.exist) {
                count++;
            }
        });

        if (family.parent.length > 0) {
            // 親Version
            family.parent.forEach((row, i) => {
                if (!row.exist) {
                    parentCount ++;
                    count++;
                } else {
                    let c = false;
                    row.grand_parent.forEach((r, j) => {
                        if (!r.exist) {
                            if (!c) {
                                parentCount ++;
                                c = true;
                            }
                            count++;
                        }
                    });
                }
            });
        } else if (family.brother.length > 0) {
            // 兄弟Version
            family.brother.forEach((row, i) => {
                if (!row.exist) {
                    brotherCount ++;
                    count++;
                } else {
                    let c = false;
                    row.grand_child.forEach((r, j) => {
                        if (!r.exist) {
                            if (!c) {
                                brotherCount ++;
                                c = true;
                            }
                            count++;
                        }
                    });
                }
            });
        } else {
            // 子供・孫Version
            family.spouse.forEach((row, i) => {
                row.children.forEach((child, j) => {
                    if (!child.exist) {
                        count++;
                        childCount++;
                    } else {
                        let c = false;
                        child.grand_child.forEach((grandChild, k) => {
                            if (!grandChild.exist) {
                                if (!c) {
                                    childCount ++;
                                    c = true;
                                }
                                count++;
                            }
                        });
                    }
                });
            });
        }

        return {
            total: count,
            child: childCount,
            parent: parentCount,
            brother: brotherCount,
        };
    },

    // 祖父母計算
    mathParent(obj) {
        let parentPrice = 0;
        let allTaxPrice = 0;
        if (obj.family.spouse.length === 0) {
            parentPrice = (obj.イ + obj.priceData.deathKouzyo);
            allTaxPrice = obj.ニ;
        } else {
            obj.family.spouse.forEach((row, i) => {
                if (i === 0) {
                    if (!row.exist) {
                        if (obj.targetMemberCount.parent > 0) {
                            parentPrice = parseInt((obj.イ + obj.priceData.deathKouzyo) / 3, 10);
                            allTaxPrice = parseInt(obj.ニ / 3, 10);
                        }
                        row.price = (obj.イ + obj.priceData.deathKouzyo) - parentPrice;
                        const tax = obj.ニ - allTaxPrice;
                        // obj.taxPrice += parseInt(this.tax(tax), 10);
                        // row.tax = parseInt(this.tax(tax), 10);
                        row.tax = 0;
                    } else {
                        row.price = 0;
                        row.tax = 0;
                        parentPrice = (obj.イ + obj.priceData.deathKouzyo);
                        allTaxPrice = obj.ニ;
                    }
                } else {
                    row.price = 0;
                    row.tax = 0;
                }
            });
        }

        obj.family.parent.forEach((parent, i) => {
            const myParentPrice = parseInt(parentPrice / obj.targetMemberCount.parent, 10);
            const taxParentPrice = parseInt(allTaxPrice / obj.targetMemberCount.parent, 10);
            if (!parent.exist) {
                obj.taxPrice += parseInt(this.tax(taxParentPrice), 10);
                parent.tax = this.tax(taxParentPrice);
                parent.price = myParentPrice;
                parent.grand_parent.forEach((grandParent, k) => {
                    grandParent.price = 0;
                    grandParent.tax = 0;
                });
            } else {
                // 祖父母計算
                parent.price = 0;
                parent.tax = 0;
                let grandParentCount = 0;
                // 件数チェック
                parent.grand_parent.forEach((grandParent, k) => {
                    if (!grandParent.exist) {
                        grandParentCount++;
                    }
                });
                // 金額設定
                parent.grand_parent.forEach((grandParent, k) => {
                    if (!grandParent.exist) {
                        obj.taxPrice += parseInt(this.tax(parseInt(taxParentPrice / grandParentCount, 10)), 10);
                        grandParent.tax = this.tax(parseInt(taxParentPrice / grandParentCount, 10));
                        grandParent.price = parseInt(myParentPrice / grandParentCount, 10);
                    } else {
                        grandParent.tax = 0;
                        grandParent.price = 0;
                    }
                });
            }
        });
    },

    // 兄弟計算
    mathBrother(obj) {
        let parentPrice = 0;
        let allTaxPrice = 0;
        if (obj.family.spouse.length === 0) {
            parentPrice = (obj.イ + obj.priceData.deathKouzyo);
            allTaxPrice = obj.ニ;
        } else {
            obj.family.spouse.forEach((row, i) => {
                if (i === 0) {
                    if (!row.exist) {
                        if (obj.targetMemberCount.brother > 0) {
                            parentPrice = parseInt((obj.イ + obj.priceData.deathKouzyo) / 4, 10);
                            allTaxPrice = parseInt(obj.ニ / 4, 10);
                        }
                        row.price = (obj.イ + obj.priceData.deathKouzyo) - parentPrice;
                        // this.taxPrice += parseInt(this.tax(tax), 10);
                        // row.tax = parseInt(this.tax(tax), 10);
                        row.tax = 0;
                    } else {
                        row.price = 0;
                        row.tax = 0;
                        parentPrice = (obj.イ + obj.priceData.deathKouzyo);
                        allTaxPrice = obj.ニ;
                    }
                } else {
                    row.price = 0;
                    row.tax = 0;
                }
            });
        }

        obj.family.brother.forEach((brother, i) => {
            const myParentPrice = parseInt(parentPrice / obj.targetMemberCount.brother, 10);
            const taxParentPrice = parseInt(allTaxPrice / obj.targetMemberCount.brother, 10);
            if (!brother.exist) {
                obj.taxPrice += parseInt(this.tax(taxParentPrice), 10);
                brother.tax = this.tax(taxParentPrice);
                brother.price = myParentPrice;
                brother.grand_child.forEach((grandParent, k) => {
                    grandParent.price = 0;
                    grandParent.tax = 0;
                });
            } else {
                // 祖父母計算
                brother.price = 0;
                brother.tax = 0;
                let grandParentCount = 0;
                // 件数チェック
                brother.grand_child.forEach((grandParent, k) => {
                    if (!grandParent.exist) {
                        grandParentCount++;
                    }
                });
                // 金額設定
                brother.grand_child.forEach((grandParent, k) => {
                    if (!grandParent.exist) {
                        obj.taxPrice += parseInt(this.tax(parseInt(taxParentPrice / grandParentCount, 10)), 10);
                        grandParent.tax = this.tax(parseInt(taxParentPrice / grandParentCount, 10));
                        grandParent.price = parseInt(myParentPrice / grandParentCount, 10);
                    } else {
                        grandParent.tax = 0;
                        grandParent.price = 0;
                    }
                });
            }
        });
    },

    // 子供計算
    mathChild(obj) {
        let allChildPrice = 0;
        let allTaxChildPrice = 0;

        obj.family.spouse.forEach((row, i) => {
            if (i === 0) {
                if (!row.exist) {
                    if (obj.targetMemberCount.child > 0) {
                        allChildPrice = parseInt((obj.イ + obj.priceData.deathKouzyo) / 2, 10);
                        allTaxChildPrice = parseInt(obj.ニ / 2, 10);
                    } else {
                        allChildPrice = parseInt((obj.イ + obj.priceData.deathKouzyo), 10);
                        allTaxChildPrice = parseInt(obj.ニ, 10);
                    }
                    row.price = allChildPrice;
                    // obj.taxPrice += parseInt(this.tax(allTaxChildPrice), 10);
                    // row.tax = parseInt(this.tax(allTaxChildPrice), 10);
                    row.tax = 0;
                } else {
                    row.price = 0;
                    row.tax = 0;
                    allChildPrice = (obj.イ + obj.priceData.deathKouzyo);
                    allTaxChildPrice = obj.ニ;
                }
            } else {
                row.price = 0;
                row.tax = 0;
            }

            row.children.forEach((child, j) => {
                const childPrice = parseInt(allChildPrice / obj.targetMemberCount.child, 10);
                const taxChildPrice = parseInt(allTaxChildPrice / obj.targetMemberCount.child, 10);
                if (!child.exist) {
                    obj.taxPrice += parseInt(this.tax(taxChildPrice), 10);
                    child.tax = this.tax(taxChildPrice);
                    child.price = childPrice;
                    child.grand_child.forEach((grandChild, k) => {
                        grandChild.price = 0;
                        grandChild.tax = 0;
                    });
                } else {
                    // 孫計算
                    child.price = 0;
                    child.tax = 0;
                    let grandChildCount = 0;
                    // 件数チェック
                    child.grand_child.forEach((grandChild, k) => {
                        if (!grandChild.exist) {
                            grandChildCount++;
                        }
                    });
                    // 金額設定
                    child.grand_child.forEach((grandChild, k) => {
                        if (!grandChild.exist) {
                            obj.taxPrice += parseInt(this.tax(parseInt(taxChildPrice / grandChildCount, 10)), 10);
                            grandChild.tax = this.tax(parseInt(taxChildPrice / grandChildCount, 10));
                            grandChild.price = parseInt(childPrice / grandChildCount, 10);
                        } else {
                            grandChild.tax = 0;
                            grandChild.price = 0;
                        }
                    });
                }
            });
        });
    },

    // PDF出力用の家族パラメータ
    pdfFamilyParam(family) {
        let returnParam = [];
        family.spouse.forEach((row, i) => {
            returnParam.push(this.createHashParam(row, 0));

            row.children.forEach((child, j) => {
                returnParam.push(this.createHashParam(child, 1));
                child.grand_child.forEach((grandChild, k) => {
                    returnParam.push(this.createHashParam(grandChild, 2));
                });
            });
        });
        family.parent.forEach((parent, i) => {
            returnParam.push(this.createHashParam(parent, 1));
            parent.grand_parent.forEach((grandParent, k) => {
                returnParam.push(this.createHashParam(grandParent, 2));
            });
        });
        family.brother.forEach((brother, i) => {
            returnParam.push(this.createHashParam(brother, 1));
            brother.grand_child.forEach((grandParent, k) => {
                returnParam.push(this.createHashParam(grandParent, 2));
            });
        });

        return returnParam;
    },

    // パラメータ作成
    createHashParam(row, depth) {
      return {
          label: row.label,
          exist: row.exist,
          price: row.price,
          tax: row.tax,
          comment: row.comment,
          depth: depth,
      };
    },

    // 数値フォーマット
    comma(price) {
        return String(price).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    },

    // 税率計算
    tax(price) {
        if (!price) {
            return 0;
        }
        let p = 0;
        if (price < 1000) {
            p = price * 0.1;
        } else if (price < 3000) {
            p = price * 0.15 - 50;
        } else if (price < 5000) {
            p = price * 0.2 - 200;
        } else if (price < 10000) {
            p = price * 0.3 - 700;
        } else if (price < 20000) {
            p = price * 0.4 - 1700;
        } else if (price < 30000) {
            p = price * 0.45 - 2700;
        } else if (price < 60000) {
            p = price * 0.5 - 4200;
        } else {
            p = price * 0.55 - 7200;
        }
        return parseInt(p, 10);
    },
};